// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentSummary_root_2X097","item":"PaymentSummary_item_5grg9"};